export const useGetQueryString = () => {
  const referrerURL: string = window.location.href;
  const referrer = new URL(referrerURL);
  const uid = referrer.searchParams.get("hUId");

  localStorage.setItem("uid", uid || "");
  console.log("uid", localStorage.getItem("uid"));
};
